<template>
  <div class="box">
    <img src="../assets/img/success.png" alt="" />
    <div class="box-span">注册成功</div>
    <div
      style="width: 100%; border-bottom-style: solid; border-bottom-width: 1px"
    >
      <div class="item">
        <div>云购名称:</div>
        <div class="item-value">
          {{ form.name }}
        </div>
      </div>
      <div class="item">
        <div>云购账号:</div>
        <div class="item-value">
          {{ form.account }}
        </div>
      </div>
      <div class="info">
        <i class="el-icon-info"></i>
        若您是店员代为注册，请将云购账号发予门店老板
      </div>
      <div class="item">
        <div>云购官网:</div>
        <div>fsyg.cn</div>
      </div>
    </div>

    <div>
      <fieldset id="downbox">
        <legend>
          &nbsp;&nbsp;<span style="font-size:20px">完成升级，还差3步</span>&nbsp;&nbsp;
        </legend>
      </fieldset>
      <div>
        <el-row :gutter="10">
          <el-col :span="8">
            <div style="text-align:center;">
              <i class="el-icon-download" style="font-weight:1200;font-size:50px"></i>
              <div style="font-weight:1200;font-size:24px;padding:5px">
                安装
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div style="text-align:center;">
              <i class="el-icon-open" style="font-weight:1200;font-size:50px"></i>
              <div style="font-weight:1200;font-size:24px;padding:5px">
                关停
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div style="text-align:center;">
              <i class="el-icon-thumb" style="font-weight:1200;font-size:50px"></i>
              <div style="font-weight:1200;font-size:24px;padding:5px">
                导入
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" style="font-size:12px;text-align:center;padding:20px 10px">
          <el-col :span="8" >
            <div style="border:solid black 1px;border-radius:5px">
              在“网吧管家”超市中<br/>
              <b>1.下载云购并安装</b>
            </div>
          </el-col>
          <el-col :span="8">
            <div style="border:solid black 1px;border-radius:5px">
              在“网吧管家”超市中<br/>
              <b>2.关停超市</b>
            </div>
          </el-col>
          <el-col :span="8" >
            <div style="border:solid black 1px;border-radius:5px">
              请登录“云购收银端”<br/>
              <b>3.数据导入</b>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="text-align:center;justify-content: center;">
        <div>
          如需人工帮助，请联系
        </div>
        <div style="border:solid #00000075 0.5px;width:80%;position: absolute;margin-left: 10%;margin-top:5px"></div>
      </div>
      <el-row :gutter="10" style="margin-top:25px;text-align: center;">
        <el-col :span="24">
          <!-- <div style="margin-top:25px;justify-content: center;">
        <div style="display:flex;width:80%;text-align:center;"> -->
          <div>
            <i class="el-icon-phone" style="font-size:24px"></i>
            <a href="tel:4000309003">4000309003</a>

          </div>
          
        <!-- </div>
      </div> -->
        </el-col>
        <!-- <el-col :span="12">
          <div>
           <i class="el-icon-service" style="font-size:24px"></i> 微信人工客服
          </div>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        account: "123",
        name: "123",
      },
    };
  },
  created() {
    this.form = this.$route.query
    // console.log(this.$route.query.account)
  },
};
</script>

<style scoped  >
.account {
  margin: 10px;
  color: red;
  font-size: 20px;
  font-weight: bold;
}
.box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
img {
  margin-top: 10%;
  width: 25%;
  margin-bottom: 15px;
}
.box-span {
  font-weight: 600;
  font-size: 20px;
}
.item {
  /* width: 100%; */
  display: flex;
  justify-content: space-between;
  padding: 15px 30px;
  font-size: 16px;
  color: #4b4a4a;
}
.item-value {
  color: red;
  font-weight: bold;
}
.info {
  width: 100%;
  font-size: 10px;
  padding-left: 30px;
  /* text-align:right; */
  color: #4b4a4a;
  /* float: right; */
}
.footer-border {
  font-size: 20px;
  font-weight: bold;
}
 #downbox{
        display: block;
        margin-top: 20px;
        height: 30px;
        width: 90vw;
        margin-left:5vw;
        border-top:dotted black 2px;
        border-bottom:none ;
        border-left: none;
        border-right: none;
    }
    #downbox legend{
        font-weight:600;
        color: black;
        opacity: 1;
        font-size: 12px;
        margin:0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Success.vue